/* Uses Dawn's current variant and Shopify's cart, never a parallel cart. */
if (!customElements.get('chelin-whatsapp')) {
  let cartRevision = 0;
  document.addEventListener('change', event => {
    if (event.target.closest('cart-items, cart-drawer-items')) cartRevision++;
  });
  document.addEventListener('click', event => {
    if (event.target.closest('cart-remove-button')) cartRevision++;
  });
  document.addEventListener('submit', event => {
    if (event.target.closest('product-form')) cartRevision++;
  });
  // Delegate clicks: Dawn and Shopify can replace/clone cart descendants after AJAX updates.
  document.addEventListener('click', event => {
    const button = event.target.closest('chelin-whatsapp button');
    if (!button || button.disabled) return;
    const component = button.closest('chelin-whatsapp');
    component.button = button;
    component.status = component.querySelector('[role="status"]');
    component.open();
  });
  customElements.define('chelin-whatsapp', class extends HTMLElement {
    static money(cents, currency) {
      if (!Number.isFinite(cents)) throw new Error('No pudimos verificar el precio. Intenta de nuevo.');
      return `${currency === 'COP' ? '$' : ''}${new Intl.NumberFormat('es-CO', { maximumFractionDigits: 2 }).format(cents / 100)} ${currency}`;
    }

    static productUrl(path, origin, variant) {
      const url = new URL(path, origin);
      // Only a public product path and variant are shared, never preview/session parameters.
      if (url.origin !== new URL(origin).origin || !url.pathname.includes('/products/')) {
        throw new Error('No pudimos verificar el enlace del producto.');
      }
      url.search = '';
      url.hash = '';
      if (variant) url.searchParams.set('variant', variant);
      return url.href;
    }

    static cartMessage(cart, origin) {
      if (!cart.items?.length) throw new Error('Tu carrito está vacío. Agrega una prenda para consultar.');
      const rows = cart.items.map((item, index) => {
        const options = (item.options_with_values || [])
          .filter(option => option.value !== 'Default Title')
          .map(option => `${option.name}: ${option.value}`);
        return [
          `${index + 1}. ${item.product_title}`,
          ...options,
          `Cantidad: ${item.quantity}`,
          `Precio por unidad: ${this.money(item.final_price, cart.currency)}`,
          `Total de la línea: ${this.money(item.final_line_price, cart.currency)}`,
          `Enlace: ${this.productUrl(item.url, origin, item.variant_id)}`,
        ].join('\n');
      });
      return [
        'Hola, Chelín',
        'Quiero consultar disponibilidad y pedir estas prendas:',
        ...rows,
        `Subtotal: ${this.money(cart.total_price, cart.currency)}`,
        'Quedo pendiente de confirmar disponibilidad, envío y forma de pago. ¡Gracias!',
      ].join('\n\n');
    }

    static productMessage(data, variant) {
      if (!variant) throw new Error('Selecciona una combinación de talla válida para consultar.');
      return [
        'Hola, Chelín',
        'Me interesa esta prenda:',
        [`Producto: ${data.title}`,
          ...(data.defaultVariant === 'true' ? [] : [`Variante / talla: ${variant.title}`]),
          `Precio publicado: ${this.money(variant.price, data.currency)}`,
          `Enlace: ${this.productUrl(data.url, data.origin, variant.id)}`].join('\n'),
        '¿Me pueden confirmar disponibilidad?',
      ].join('\n\n');
    }

    static link(phone, message) {
      const digits = phone.replace(/[\s()+-]/g, '');
      if (!/^[1-9]\d{7,14}$/.test(digits)) {
        throw new Error('El número de WhatsApp no está configurado correctamente.');
      }
      return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
    }

    async open() {
      this.status.textContent = '';
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      try {
        const type = this.constructor;
        let message;
        if (this.dataset.context === 'product') {
          const info = this.closest('product-info');
          if (info?.pendingRequestUrl) throw new Error('Espera a que termine de actualizarse la talla.');
          const variant = JSON.parse(info?.querySelector('[data-selected-variant]')?.textContent || 'null');
          message = type.productMessage(this.dataset, variant);
        } else {
          // Allow Dawn's debounced quantity change to start before reading the cart.
          await new Promise(resolve => setTimeout(resolve, 500));
          if (document.querySelector('.cart__items--disabled, product-form .loading')) {
            throw new Error('El carrito se está actualizando. Intenta de nuevo cuando termine.');
          }
          const revision = cartRevision;
          const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
            cache: 'no-store', headers: { Accept: 'application/json' },
          });
          if (!response.ok) throw new Error('No pudimos actualizar el carrito. Intenta de nuevo.');
          message = type.cartMessage(await response.json(), this.dataset.origin);
          // Dawn replaces cart sections after changes. Never navigate from an obsolete button.
          if (!this.isConnected) return;
          if (revision !== cartRevision || document.querySelector('.cart__items--disabled, product-form .loading')) {
            throw new Error('El carrito cambió. Vuelve a pulsar el botón cuando termine de actualizarse.');
          }
        }
        window.location.assign(type.link(this.dataset.phone, message));
      } catch (error) {
        this.status.textContent = error.message || 'No pudimos preparar la consulta. Intenta de nuevo.';
      } finally {
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }
    }
  });
}
